import { render, staticRenderFns } from "./MenuClassList.vue?vue&type=template&id=4a9824c0&scoped=true"
import script from "./MenuClassList.vue?vue&type=script&lang=js"
export * from "./MenuClassList.vue?vue&type=script&lang=js"
import style0 from "./MenuClassList.vue?vue&type=style&index=0&id=4a9824c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9824c0",
  null
  
)

export default component.exports